var React = require('react');

function SubfooterLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M257.035 123.624L255.861 209.353L68.1239 100.418L67.5376 143.223L-120 247.689L-118.803 160.342L68.7341 55.8762L-115.856 -54.8442L-114.683 -140.456L69.9069 -29.7355L70.494 -72.5954L261.206 -180.859L259.991 -92.1748L69.2994 14.611L257.035 123.624Z","stroke":"#FFCC00","strokeWidth":"0.617842"}));
}

SubfooterLeft.defaultProps = {"width":"262","height":"249","viewBox":"0 0 262 249","fill":"none"};

module.exports = SubfooterLeft;

SubfooterLeft.default = SubfooterLeft;
